more.volume = {
    // Volume control Popup - ovládanie hlasitosti
    showVolumeControlPopup() {
        var volumeStep = 5;
        var volumeButtonStep = 25;

        var content = `
            <div class="volume-popup">
                <span class="icon icon-volume" data-class="icon-volume-mute"></span>
                <button class="plus">+</button>
                <div class="slider-wrapper">
                    <div class="slider"><div class="slider--value" style="height:${profile.CurrentVolume}%"></div></div>
                    <input type="range" name="volumeSlider" id="volumeSlider" value="${profile.CurrentVolume}" min="0" max="100" step="${volumeStep}" orient="vertical" />
                </div>
                <button class="minus">-</button> 
            </div>
        `;

        dialog.open({
            id: "volumePopup",
            content: content,
            parseJQM: false,
            shown: function() {
                var volumeSlider = document.getElementById('volumeSlider');
                var sliderValue = document.querySelector('#volumePopup .slider--value');
                var volumeButtons = document.querySelectorAll('#volumePopup button');
                
                // Inicializácia event handlerov po zobrazení dialógu
                var handleSliderChange = (e) => {
                    sliderValue.style.height = e.target.value + "%";
                    var volumeMultiplier = Number(profile?.MaxVolume || 80) / 100;
                    var volumeToSet = Math.floor(Number(e.target.value) * volumeMultiplier);
                    more.volume.setVolume(volumeToSet);
                };

                volumeSlider.addEventListener('input', handleSliderChange);
                
                volumeButtons.forEach(button => {
                    button.addEventListener('mousedown', (e) => {
                        var currentValue = Number(volumeSlider.value);
                        if (button.classList.contains('plus')) {
                            volumeSlider.value = currentValue + volumeButtonStep;
                        } else {
                            volumeSlider.value = currentValue - volumeButtonStep;
                        }
                        // Manuálne zavolanie eventu 'input' po zmene hodnoty tlačidlom, aby sa aktualizoval slider a nastavila hlasitosť
                        volumeSlider.dispatchEvent(new Event('input'));
                    });
                });

                // Nastavenie ikon zvuku podľa aktuálnej hodnoty hlasitosti pri zobrazení dialógu
                more.volume.setVolumeIcon(profile?.CurrentVolume || 0);
            },
        });
    },

    // Nastavenie ikon zvuku podľa aktuálnej hodnoty hlasitosti
    setVolumeIcon(volume) {
        var volumeValue = volume * (100 / (profile?.MaxVolume || 80));
        var volumeIconClass = 'icon-volume-0';

        switch (true) {
            case (volumeValue == 0):
                volumeIconClass = 'icon-volume-mute';
                break;
            case (volumeValue < 25 ):
                volumeIconClass = 'icon-volume-0';
                break;
            case (volumeValue < 50):
                volumeIconClass = 'icon-volume-1';
                break;
            case (volumeValue < 75):
                volumeIconClass = 'icon-volume-2';
                break;
            case (volumeValue >= 75):
                volumeIconClass = 'icon-volume-up';
                break;
            default:
                break;
        }
        
        document.querySelectorAll('#setVolumeToggle .icon, #volumePopup .icon').forEach(icon => {
            icon.setAttribute('data-class', volumeIconClass);
        });
    },

    // Funkcia na nastavenie hlasitosti
    setVolume(volume) {
        try {
            if (!volume) volume = 0;
            volume = parseInt(volume);
            // Nastavenie hlasitosti na nativapp
            ChangeVolume(volume);

            // Uloženie aktuálne nastavenej hlasitosti do globálnej premennej 
            profile.CurrentVolume = volume;

            // Nastavenie ikon zvuku podľa aktuálnej hodnoty hlasitosti
            more.volume.setVolumeIcon(volume);

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            modal.showErrObj(2, 5, {err1: texts.SetVolumeErr, errType: "SetVolumeErr"});
            return false;
        }
    }
};
